import React, { useState } from 'react';
import Grid from '@material-ui/core/Grid';
import Link from '@material-ui/core/Link';
import Container from '@material-ui/core/Container';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';

import agLogo from './assets/ag-logo-blue.svg';

const TITLE_WIDTH = 6;
const GH_API_URL = 'https://api.github.com/repos/ffmpegwasm/ffmpeg.wasm';
const GH_URL = 'https://github.com/ffmpegwasm/ffmpeg.wasm';

const useStyles = makeStyles({
  bg:{
    background:"#FFF"
  },
  root: {
    height: 64,
  },
  logo: {
    width: 32,
    height: 32,
  },
  starRoot: {
    padding: '4px 4px',
    margin: '0px 8px',
  },
  starText: {
    paddingLeft: 4,
  },
});

function AppBar() {
  const classes = useStyles();
  
  return (
    <div className={classes.bg}>
      <Container maxWidth="md">
        <Grid container direction="row" alignItems="center" className={classes.root}>
          <Link href="https://www.getaudiogram.com/">
            <img src={agLogo} /> 
          </Link>
        </Grid>
      </Container>
    </div>
  );
}

export default AppBar;
